import React, { useEffect, useState } from "react";
import KickImage from 'Reuseables/KickImage';
import { connect } from "react-redux";
import { Modal } from "reactstrap";
import classNames from "classnames";

import InputRadio from "../Forms/Input/Radio";
import SwitchToggle from "../Forms/SwitchToggle";

import {
  BANKTRANSFER,
  CREDITCARD,
  FULLWALLET,
  AKULAKU,
  MANDIRI_VA,
  BCA_VA,
  VIRTUALACCOUNT,
  BCA_INSTALLMENTS,
  DEFAULT_CREDIT_CARD,
  DEFAULT_PAYMENT_METHOD,
} from "../../constants/paymentMethods";
import { convertToRupiah, getCloudImageUrl } from "../../utils";
import { RESOURCE_URL as ASSET_IMAGE } from "../../config";

import CloseIcon from "../../images/close-button-black.png";
import Back from "../../images/back.png";

const ModalUserCredit = ({ balance, sellerCredit, kickPoints, totalAmount, useKickPoints, setUseKickPoints, paymentType, setPaymentType, setTemporaryPaymentMethod, handleCurrentPaymentType, temporaryPaymentMethod, newTotalAmount }) => {
  const totalCreditBalance = Number(balance) + Number(sellerCredit);
  const itemFullWallet = {
    'label': 'Full Wallet',
    'payment_method': FULLWALLET,
    'payment_group': 3,
    'active': true,
    'logo': `${ASSET_IMAGE}email/kick_check.png`
  }
  console.log("TOTAL CREDIT BALANCE", totalCreditBalance, totalAmount, newTotalAmount)

  return (
    <div className="payment-method-wrapper update-payment-method-wrapper">
      <div className={classNames("update-payment-method-outer-wrapper user-credit", { "is-selected": paymentType === FULLWALLET || temporaryPaymentMethod && temporaryPaymentMethod.payment_method === FULLWALLET })} onClick={() => {
        setTemporaryPaymentMethod(itemFullWallet)
        handleCurrentPaymentType(temporaryPaymentMethod)
      }}>
        <KickImage
          className="payment-methods-logo-update-payment"
          src={getCloudImageUrl(`${ASSET_IMAGE}email/kick_check.png`, 200)}
          alt="payments-logo"
        />
        <div className="all-credit-wrapper">
          <p className="title">Credit</p>
          <p>Balance: {convertToRupiah(totalCreditBalance)}</p>
          <div className="user-credit-wrapper">
            <p>Kick Credit {convertToRupiah(Number(balance))}</p>
            <p>Seller Credit {convertToRupiah(Number(sellerCredit))}</p>
          </div>
        </div>
      </div>
      <div className="update-payment-method-outer-wrapper user-credit">
        <div className="all-credit-wrapper">
          <p className="title">Use Kick Points</p>
          <p>Balance: {convertToRupiah(Number(kickPoints))}</p>
        </div>
        <SwitchToggle
          active={useKickPoints}
          onClick={() => setUseKickPoints(!useKickPoints)}
          disabled={Number(kickPoints) === 0 || totalCreditBalance > Number(newTotalAmount)}
        />
      </div>
    </div>
  )
}

function ModalUpdatePaymentOffer({
  isModalOpen,
  dataCart,
  currency,
  dataProductDetails,
  dataOffer,
  dataAuth,
  onToggle,
  handleCurrentPaymentType,
  isSelectPaymentFlagging,
  currentShippingPrice,
  currentOfferData
}) {
  const [isIndonesian, setIsIndonesia] = useState(false);
  const [paymentMethods, setPaymentMethods] = useState(DEFAULT_PAYMENT_METHOD);
  const [paymentType, setPaymentType] = useState(
    currency === "IDR" ? MANDIRI_VA : CREDITCARD
  );
  const [temporaryPaymentMethod, setTemporaryPaymentMethod] = useState(null);
  const [paymentLabel, setPaymentLabel] = useState(null);
  const [openUserCredit, setOpenUserCredit] = useState(false);
  const [useKickPoints, setUseKickPoints] = useState(false);
  const [isUseCredit, setUseCredit] = useState(false);

  useEffect(() => {
    const setPayment = [];
    const variant_payment_methods =
      dataOffer.data && dataOffer.data.product_variant.variant_payment_methods;

    if (variant_payment_methods && variant_payment_methods.length > 0) {
      (async () => {
        const dataPayments = paymentMethods.map((payments) => {
          let variantPaymentMethod = Object.assign({}, payments);
          variant_payment_methods.find((item) => {
            if (!setPayment.includes(payments.payment_method))
              variantPaymentMethod.active = false;
            else variantPaymentMethod.active = true;
          });
          return variantPaymentMethod;
        });

        let isBankTransfer = [];
        let newDataPayment = [];

        dataPayments.forEach((payments) => {
          if (payments.payment_method === "bank_transfer") {
            isBankTransfer.push(payments);
          } else {
            newDataPayment.push(payments);
          }
        });

        await setPaymentMethods(newDataPayment.concat(isBankTransfer));
      })();
    }

    if (dataOffer.data) {
      const { payment_type, lbalance_amount } = dataOffer.data;
      setPaymentType(payment_type)
      if (Number(lbalance_amount) > 0) setUseKickPoints(true)
    }

    if (
      dataAuth &&
      dataAuth.userdata &&
      dataAuth.userdata.country_code === "IDN"
    ) {
      setIsIndonesia(true);
    }
  }, [dataOffer.data]);

  useEffect(() => {
    paymentMethods &&
      paymentMethods.forEach((item) => {
        if (
          item.payment_group === 1 ||
          (item.payment_group === 3 && item.payment_method !== AKULAKU)
        ) {
          if (paymentType === item.payment_method) {
            handleCurrentPaymentType(item);
          }
        }
      });
  }, [paymentType]);

  return (
    <Modal
      isOpen={isModalOpen}
      toggle={onToggle}
      className="payment-method-container"
    >
      <div className="update-payment-method-header-wrapper" style={openUserCredit ? { gridTemplateColumns: "1fr 22fr 1fr" } : { gridTemplateColumns: "22fr 1fr" }}>
        {
          openUserCredit && (
            <KickImage
              className="back-img"
              src={Back}
              alt="..."
              onClick={() => {
                setOpenUserCredit(false)
                setTemporaryPaymentMethod(null)
              }}
            />
          )
        }
        <p>PAYMENT METHOD</p>
        <KickImage
          src={CloseIcon}
          style={{ width: "15px" }}
          alt="..."
          onClick={() => {
            onToggle()
            setOpenUserCredit(false)
          }} />
      </div>
      <div className="update-payment-list-wrapper">
        {
          openUserCredit ?
            <ModalUserCredit
              balance={dataAuth.userdata.balance}
              sellerCredit={dataAuth.userdata.balance_with_fee}
              kickPoints={dataAuth.userdata.locked_balance}
              totalAmount={dataOffer.data && dataOffer.data.total_amount}
              setUseKickPoints={setUseKickPoints}
              useKickPoints={useKickPoints}
              paymentType={paymentType}
              setPaymentType={setPaymentType}
              setTemporaryPaymentMethod={setTemporaryPaymentMethod}
              handleCurrentPaymentType={handleCurrentPaymentType}
              temporaryPaymentMethod={temporaryPaymentMethod}
              newTotalAmount={Number(dataOffer.data && currentOfferData + currentShippingPrice)}
            />
            :
            <div className="payment-method-wrapper update-payment-method-wrapper">
              {paymentMethods &&
                paymentMethods.map((item, index) => {
                  if (
                    item.payment_group === 3
                  ) {
                    return (
                      <>
                        {item.payment_method == FULLWALLET && (
                          <div className={"payment-methods-section-title"}>
                            <p>Credit</p>
                            <p>
                              Your payment will be verified automatically by the
                              payment gateway.
                        </p>
                          </div>
                        )}
                        <div
                          key={item.id}
                          className="update-payment-method-outer-wrapper"
                          onClick={() => setOpenUserCredit(true)}
                        >
                          <InputRadio
                            creditCard={item.payment_method === DEFAULT_CREDIT_CARD}
                            bordered={[
                              BANKTRANSFER,
                              VIRTUALACCOUNT,
                              BCA_INSTALLMENTS,
                            ].includes(item.payment_method)}
                            title={
                              ![
                                BANKTRANSFER,
                                DEFAULT_CREDIT_CARD,
                                BCA_INSTALLMENTS,
                              ].includes(item.payment_method)
                                ? "Virtual Account"
                                : null
                            }
                            name="_paymentType"
                            active={
                              item.active &&
                              isIndonesian &&
                              Number(dataOffer.data && currentOfferData + currentShippingPrice) < ((Number(dataAuth.userdata.balance) + Number(dataAuth.userdata.balance_with_fee) + Number(dataAuth.userdata.locked_balance)))
                            }
                            value={item.payment_method}
                            item={item}
                            checked={paymentType === item.payment_method}
                            onChange={(e) => {
                              setPaymentType(e.target.value);
                              setTemporaryPaymentMethod(item);
                              handleCurrentPaymentType(temporaryPaymentMethod);
                            }}
                            subTitle={
                              item.payment_method === BANKTRANSFER
                                ? "Payment verification manually. (Only office hours)."
                                : item.payment_method !== BCA_INSTALLMENTS
                                  ? "Payment verification automatically."
                                  : null
                            }
                            isBuyingOfferDetail={true}
                            balance={dataAuth.userdata.balance}
                            sellerCredit={dataAuth.userdata.balance_with_fee}
                            kickPoints={dataAuth.userdata.locked_balance}
                            totalAmount={dataOffer.data && dataOffer.data.total_amount}
                            newTotalAmount={Number(dataOffer.data && currentOfferData + currentShippingPrice)}
                          >
                            {"Credit"}
                          </InputRadio>
                        </div>
                      </>
                    );
                  }
                  return null;
                })}

              {/* INI UNTUK RENDER VIRTUAL ACCOUNT */}
              {paymentMethods &&
                paymentMethods.map((item, index) => {
                  if (
                    item.payment_group === 1
                  ) {
                    return (
                      <>
                        {item.label == "BCA Installments" && (
                          <div className={"payment-methods-section-title"}>
                            <p>Credit Card</p>
                            <p>
                              Your payment will be verified automatically by the
                              payment gateway.
                        </p>
                          </div>
                        )}
                        {item.payment_method == BCA_VA && (
                          <div className={"payment-methods-section-title"}>
                            <p>Virtual Account</p>
                            <p>
                              Your payment will be verified automatically by the
                              payment gateway.
                        </p>
                          </div>
                        )}
                        {item.payment_method == BANKTRANSFER && (
                          <div className={"payment-methods-section-title"}>
                            <p>Bank Transfer</p>
                            <p>
                              Please allow 1 working day for us to verify your
                              payment.
                        </p>
                          </div>
                        )}

                        <div className="update-payment-method-outer-wrapper">
                          <InputRadio
                            creditCard={item.payment_method === DEFAULT_CREDIT_CARD}
                            bordered={[
                              BANKTRANSFER,
                              VIRTUALACCOUNT,
                              BCA_INSTALLMENTS,
                            ].includes(item.payment_method)}
                            title={
                              ![
                                BANKTRANSFER,
                                DEFAULT_CREDIT_CARD,
                                BCA_INSTALLMENTS,
                              ].includes(item.payment_method)
                                ? "Virtual Account"
                                : null
                            }
                            name="_paymentType"
                            active={
                              (item.active && isIndonesian) ||
                              (isIndonesian &&
                                item.payment_method === DEFAULT_CREDIT_CARD) ||
                              (!isIndonesian &&
                                item.payment_method === DEFAULT_CREDIT_CARD)
                            }
                            value={item.payment_method}
                            item={item}
                            checked={
                              paymentType !== "credit_card"
                                ? paymentType === item.payment_method
                                : !paymentLabel
                                  ? paymentType === item.payment_method
                                  : paymentLabel === item.label
                            }
                            onChange={(e) => {
                              item.payment_method === "credit_card"
                                ? setPaymentLabel(item.label)
                                : setPaymentLabel(null);
                              setPaymentType(item.payment_method);
                              setTemporaryPaymentMethod(item);
                            }}
                            subTitle={
                              item.payment_method === BANKTRANSFER
                                ? "Payment verification manually. (Only office hours)."
                                : item.payment_method !== BCA_INSTALLMENTS
                                  ? "Payment verification automatically."
                                  : null
                            }
                            isBuyingOfferDetail={true}
                            balance={dataAuth.userdata.balance}
                            sellerCredit={dataAuth.userdata.balance_with_fee}
                            kickPoints={dataAuth.userdata.locked_balance}
                            totalAmount={
                              dataOffer.data && dataOffer.data.total_amount
                            }
                            newTotalAmount={Number(dataOffer.data && currentOfferData + currentShippingPrice)}
                          >
                            {item.label}
                          </InputRadio>
                        </div>
                      </>
                    );
                  }
                  return null;
                })}
            </div>
        }
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod || paymentLabel ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              handleCurrentPaymentType(temporaryPaymentMethod, useKickPoints);
              setTemporaryPaymentMethod(null);
              setPaymentLabel(null);
              isSelectPaymentFlagging(true);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button update-payment-method-disable-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              // setPaymentType(e.target.value);
              handleCurrentPaymentType(temporaryPaymentMethod);
              setTemporaryPaymentMethod(null);
              onToggle();
            }}
          >
            <p>SAVE</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button">
            <p>SAVE</p>
          </div>
        )}
      </div>
    </Modal>
  );
}

const mapStateToProps = (state) => ({
  dataCart: state.dataProduct.cart,
  currency: state.dataAuth.userCurrency.currency,
  dataOffer: state.dataOffer.offerDetails,
  dataAuth: state.dataAuth,
});

export default connect(mapStateToProps)(ModalUpdatePaymentOffer);
